import { LeagueLink } from '@/interfaces/core';

export const FAKE_EMAIL = '@powerbet.io';
export const SUPPORT_EMAIL = 'soporte@powerbet.la';
export const ALGORITHM = 'aes-256-gcm';
export const DEFAULT_NICK = 'player';
export const COMING_SOON_LABEL = 'Pronto';
export const COMING_SOON_LONG_LABEL = 'Muy Pronto';

export const CURRENCY_CODE = {
  GTQ: 'GTQ',
  USD: 'USD',
  DOP: 'DOP',
} as const;
export const COMMAJOINS = ',';
export const LOCAL = 'local';
export const ROWS_PER_PAGE = 10;
export const PROHIBITED_WORDS = [
  'anal', 'marica', 'ano', 'guevo', 'coño', 'mamaguevo', 'webo', 'guevo',
  'vergonza', 'vergon', 'pito', 'putisimo', 'puti', 'puchaina', 'puchaino',
  'puta', 'puto', 'putita', 'putito', 'verga', 'mierda', 'caca',
  'pendejo', 'idiota', 'estupido', 'imbecil', 'cabron', 'chingar',
  'joder', 'coger', 'mamar', 'culero', 'culo', 'perra', 'zorra',
  'maricon', 'putoamo', 'putamadre', 'hijueputa', 'folla', 'porno', 'pornografia',
  'gonorrea', 'malparido', 'berraco', 'güevón', 'huevon', 'boludo',
  'pelotudo', 'tarado', 'retrasado', 'mamón', 'mamerto', 'carechimba',
  'careculo', 'caremonda', 'carepija', 'hijuemadre', 'hijo de puta',
  'chimba', 'pija', 'pene', 'vagina', 'tetas', 'chichis', 'nalgas',
  'picha', 'mondá', 'monda', 'bicho', 'poronga', 'rabo',
  'guache', 'ordinario', 'muerto de hambre', 'gamin', 'ñero',
  'desgraciado', 'infeliz', 'miserable', 'rata', 'sapo',
  'estúpido', 'imbécil', 'cabrón', 'maricón',
  'carajo', 'demonio', 'diablo', 'maldito', 'condenado',
  'cerote', 'maje', 'baboso', 'babosa', 'chucha', 'chuzo',
  'guanaco', 'turco', 'puchica', 'choto', 'chota',
  'cipote', 'playo', 'playa', 'vergón', 'vergona',
  'pisado', 'pisada', 'zopilote', 'culillo', 'bayunco',
  'jodido', 'jodida', 'pichudo', 'pichurria', 'güiro',
  'güirro', 'culilludo', 'shuco', 'shuca', 'chancho', 'chancha',
  'fuck', 'fucking', 'fucker', 'fucked', 'motherfucker', 'fuk', 'fck',
  'shit', 'bullshit', 'horseshit', 'shitty', 'shitter',
  'bitch', 'bitches', 'bitching', 'son of a bitch', 'sob',
  'ass', 'asshole', 'arsehole', 'arse', 'dumbass', 'jackass', 'badass',
  'damn', 'goddamn', 'dammit', 'damned',
  'hell', 'hellish', 'cunt', 'twat', 'pussy',
  'dick', 'dickhead', 'prick', 'cock', 'penis',
  'bastard', 'bastards',
  'idiot', 'stupid', 'moron', 'imbecile', 'retard', 'retarded',
  'dumb', 'dummy', 'fool', 'foolish',
  'loser', 'worthless', 'pathetic', 'useless',
  'jerk', 'scumbag', 'douchebag', 'douche',
  'trash', 'garbage', 'scum',
  'whore', 'slut', 'slutty', 'hoe', 'hooker', 'prostitute',
  'boobs', 'tits', 'titties', 'boobies', 'breasts',
  'butt', 'booty', 'butthole',
  'sex', 'sexual', 'sexy', 'porn', 'porno', 'pornography',
  'rape', 'molest',
  'nigger', 'nigga', 'negro', 'coon', 'spic', 'wetback',
  'chink', 'gook', 'kike', 'cracker', 'whitey',
  'beaner', 'gringo', 'redneck',
  'fag', 'faggot', 'dyke', 'homo', 'queer', 'gay',
  'f*ck', 'f**k', 'sh*t', 'b*tch', 'a$$', '@ss',
  'fvck', 'phuck', 'shyt', 'biatch',
  'malparida', 'gonorrea', 'gonorreita', 'perrero',
  'lagarto', 'careverga', 'careleche', 'careloque',
  'caremondá', 'carepalo', 'carepeo',
  'mamaburra', 'mamahuevo', 'mamabicho',
  'maricote', 'maricotas', 'maricueca',
  'locota', 'locote', 'pajuo', 'pajuata',
  'verguita', 'vergonazo', 'vergonazo',
  'culiado', 'culiada', 'culear', 'culito',
  'chimbita', 'chimbón', 'chimbita',
  'mondongo', 'mondáo',
  'petardo', 'gilipollas', 'capullo', 'subnormal',
  'analplay', 'analplug',
  'deepthroat', 'hardcore', 'softcore',
  'cum', 'cumming', 'cumshot', 'cums', 'facial',
  'bukkake', '69', 'doggystyle',
  'hentai', 'camgirl', 'camwhore',
  'indio', 'india', 'moro', 'mora',
  'gitano', 'gitana',
  'judío', 'judia', 'musulman', 'musulmana',
  'nazi', 'nazista', 'nazi', 'nazista',
  'hitler', 'hitlerismo', 'hitlerista', 'hitlerismo',
  'fuk', 'fukc', 'fvk', 'fvk', 'fux', 'fuq',
  'sh1t', 'shlt', 'shyt', 'shyte',
  'b1tch', 'b!tch', 'bltch',
  'c0ck', 'c0k', 'c0ñ0', 'c0ño',
  'p3ne', 'p3n3', 'p3ne',
  'pvt@', 'pvta', 'pvto',
  'v3rg@', 'v3rga', 'v3rga',
  'n1gga', 'n1gg3r',
  'g4y', '6ay',
  'asesino', 'sicario', 'narco', 'narcotraficante',
  'terrorista', 'terrorismo',
  'violador', 'degollador', 'decapitar',
  'matón', 'pandillero',
  'perro', 'cerda', 'cerdo', 'burro', 'zángano',
  'mula', 'bestia', 'cuervo', 'rata inmunda'
];
export const MIN_NICKNAME_LENGTH = 3;
export const MAX_NICKNAME_LENGTH = 13;
export const MAX_NICKNAME_SUGGESTIONS = 3;
export const NICKNAME_SUGGESTION_DEBOUNCE_DELAY = 500;
export const MIN_NAME_LENGTH_FOR_SUGGESTIONS = 2;
export const PAYPHONE_CONVERSION_RATE = 0.039;
export const AUTHENTICATED_SESSION = 'authenticated';
export const FUTBOL_OPTION = {
  title: 'Futbol',
  icon: 'ball',
  type: 'sport',
  list: [
    {
      link: '/sports?leagueLink=championship/16808',
      name: 'Champions League',
      icon: 'icon-logo_championsleague',
    },
    {
      link: '/sports?leagueLink=championship/2936',
      name: 'Premier League',
      icon: 'icon-logo_premierleague1',
    },
    {
      link: '/sports?leagueLink=championship/2941',
      name: 'La Liga',
      icon: 'icon-logo_laliga_sm',
    },
    {
      link: '/sports?leagueLink=championship/16809',
      name: 'EuroLeague',
      icon: 'icon-UEFA-Europa-League-_1_',
    },
    {
      link: '/sports?leagueLink=championship/2950',
      name: 'Bundesliga',
      icon: 'icon-logo_bundesliga',
    },
  ],
};
export const MAX_WITHDRAWAL_AMOUNT = 100000;
export const MIN_WITHDRAWAL_AMOUNT = 500;
export const FINGERPRINT_RESTRICTION_STATUS = 'fingerprint-restriction';

export const MIN_BANK_VOUCHER_DEPOSIT: Record<string, number> = {
  GTQ: 100,
  DOP: 100,
  USD: 100,
};

export enum NicknameStatus {
  IDLE = 'idle',
  CHECKING = 'checking',
  AVAILABLE = 'available',
  TAKEN = 'taken',
}

export interface DepositLimits {
  min: number;
  max: number;
}

export const DEPOSIT_LIMITS: Record<string, Record<string, DepositLimits>> = {
  praxis: {
    GTQ: { min: 35, max: 60000 },
    DOP: { min: 700, max: 60000 },
    USD: { min: 10, max: 60000 },
  },
  payphone: {
    GTQ: { min: 5, max: 12500 },
    DOP: { min: 100, max: 12500 },
    USD: { min: 1, max: 2500 },
  },
  eukapay: {
    GTQ: { min: 40, max: 60000 },
    DOP: { min: 300, max: 60000 },
    USD: { min: 5, max: 60000 },
  },
  tencoins: {
    GTQ: { min: 40, max: 60000 },
    DOP: { min: 300, max: 60000 },
    USD: { min: 5, max: 60000 },
  },
  paycash: {
    GTQ: { min: 10, max: 50000 },
    DOP: { min: 50, max: 50000 },
    USD: { min: 1, max: 50000 },
  },
  praxis_cash: {
    GTQ: { min: 200, max: 50000 },
    DOP: { min: 200, max: 50000 },
    USD: { min: 1, max: 50000 },
  },
};

export function getDepositLimits(method: string, currency: string | undefined): DepositLimits {
  const userCurrency = currency || 'USD';
  const methodLimits = DEPOSIT_LIMITS[method.toLowerCase()];
  if (!methodLimits) {
    return { min: 0, max: 0 };
  }
  return methodLimits[userCurrency] || methodLimits.USD || { min: 0, max: 0 };
}
export const LEAGUES_POPULAR: LeagueLink[] = [
  {
    href: '/sports?leagueLink=championship/2941',
    src: 'icon-logo_laliga',
    alt: 'laliga',
  },
  {
    href: '/sports?leagueLink=championship/2936',
    src: 'icon-logo_premierleague',
    alt: 'premier',
  },
  {
    href: '/sports?leagueLink=championship/16808',
    src: 'icon-logo_championsleague1',
    alt: 'champions',
  },
  { href: '/sports?leagueLink=championship/2980', src: 'icon-logo_nba', alt: 'nba' },
  { href: '/sports?leagueLink=category/674', src: 'icon-logo_ufc', alt: 'ufc' },
  { href: '/sports?leagueLink=/category/574', src: 'icon-logo_afa', alt: 'afa' },
  {
    href: '/sports?leagueLink=championship/2950',
    src: 'icon-logo_bundesliga',
    alt: 'bundesliga',
  },
  {
    href: '/sports?leagueLink=championship/16809',
    src: 'icon-logo_europa_league',
    alt: 'europa',
  },
  {
    href: '/sports?leagueLink=championship/2942',
    src: 'icon-logo_serieA',
    alt: 'seriaA',
  },
  {
    href: '/sports?leagueLink=championship/2943',
    src: 'icon-logo_ligue01',
    alt: 'ligue1',
  },
  { href: '/sports?leagueLink=championship/3281', src: 'icon-logo_nfl', alt: 'nfl' },
  { href: '/sports?leagueLink=championship/3232', src: 'icon-logo_nhl', alt: 'nhl' },
];

export const AUTHENTICATED_SESSION_STATUS = 'authenticated';
export const UNAUTHENTICATED_SESSION_STATUS = 'unauthenticated';
export const LOADING_SESSION_STATUS = 'loading';
export const JWT_JOIN = '^';
export const GATEWAY_FORM_HMAC_JOIN = '^';

export const VIP_LEVELS = {
  DEFAULT: {
    wager: {
      amount: 0,
    },
    logins: 0,
    deposits: {
      quantity: 0,
      amount: 0,
    },
  },
  START: {
    wager: {
      amount: 0,
    },
    logins: 2,
    deposits: {
      quantity: 1,
      amount: 0,
    },
  },
  BASIC: {
    wager: {
      amount: 0,
    },
    logins: 4,
    deposits: {
      quantity: 2,
      amount: 0,
    },
  },
  PRO: {
    wager: {
      amount: 640000,
    },
    logins: 0,
    deposits: {
      quantity: 0,
      amount: 0,
    },
  },
  ELITE: {
    wager: {
      amount: 1500000,
    },
    logins: 0,
    deposits: {
      quantity: 0,
      amount: 0,
    },
  },
  MASTER: {
    wager: {
      amount: 3800000,
    },
    logins: 0,
    deposits: {
      quantity: 0,
      amount: 0,
    },
  },
};

export const OTP_EXPIRY_MINUTES = 10;
export const OTP_MAX_ATTEMPTS = 3;
export const OTP_CODE_MIN = 100000;
export const OTP_CODE_MAX = 999999;
export const SENDGRID_PASSWORD_CHANGE_OTP_TEMPLATE_ID = process.env.PRIVATE_SENDGRID_PASSWORD_CHANGE_OTP_TEMPLATE_ID || 'd-7fc55665996a45a2aa736aaac47b1c51';
export const FAVORITE_CLUBS = [
  {
    value: 'realespaña',
    label: 'Real España',
  },
  {
    value: 'motagua',
    label: 'Motagua',
  },
  {
    value: 'victoria',
    label: 'Victoria',
  },
  {
    value: 'olimpia',
    label: 'Olimpía',
  },
  {
    value: 'marathon',
    label: 'Marathon',
  },
  {
    value: 'lobos',
    label: 'Lobos UPNFM',
  },
  {
    value: 'olancho',
    label: 'Olancho',
  },
  {
    value: 'juticalpa',
    label: 'Juticalpa',
  },
  {
    value: 'realsociedad',
    label: 'Real Sociedad',
  },
  {
    value: 'genesis',
    label: 'Genesis',
  },
];
